import $ from 'jquery'

export default class ApplicationSlider {

	constructor() {
		//es6 like init
		this.options={
			slides:">div>section",
			startSlide:0,
			onSlideChange:null, // (slider,newindex,oldindex)
			transitionTime: 1000,
			fullheightCls:"uad_full-height",
		}
		this.slideIndex=-1;
		this.slideMax=0;
		this.stage=null;
	}

	init(options){
		//init code
		this.options={...this.options, ...options};
		this.slides=options.context.find(this.options.slides);
		this.slides.hide();
		this.slideMax=this.slides.length;
		this.goto(this.options.startSlide,false);
		this.slides.eq(this.options.startSlide).addClass("active");
	}

	scrollTop() {
		//scrollup if there was a slideMax
		if($(window).width() <= 768){ //todo - use breakpoint?
			//$("html, body").animate({ scrollTop: 0 },0);
			$(window).scrollTop(0);
		}else {
			//$("html, body").animate({ scrollTop: 179 },0);
			if ($(window).scrollTop()>179)
				$(window).scrollTop(179);
		}
	}

	next() {
		this.goto(this.slideIndex+1);
	}
	prev() {
		this.goto(this.slideIndex-1);
	}
	goto(index,anim){
		//check conditions for slide
		if (this.inTransition) return;
		if (anim===undefined) anim=true;
		if (index<0 || index>=this.slideMax || index == this.slideIndex) return;

		this.inTransition=true;

		//do we iterate backward
		const backward=this.slideIndex>index;
		const backadd=backward?"-back":"";

		//check if there was a slide
		if (this.slideIndex+1){
			var oldslide=this.slides.eq(this.slideIndex);
			if (!anim) oldslide.hide();
			//scrollup if there was a slideMax
			this.scrollTop();
		}

		//trigger before slide change
		if (this.options.onSlideChange)
			this.options.onSlideChange(this,index,this.slideIndex);

		var oldindex=this.slideIndex;
		this.slideIndex=index;
		var newslide=this.slides.eq(this.slideIndex);

		//if big slide should be fullheight add it to the stage
		if (newslide.attr("data-fullheight")){
			this.options.context.find(">div").addClass(this.options.fullheightCls);
		} else {
			this.options.context.find(">div").removeClass(this.options.fullheightCls);
		}

		newslide.show();

		//if animate do classes
		if (anim)  {
			newslide.addClass("animateIn-prep"+backadd);
			newslide.position().top; //force redraw
			newslide.addClass("animate animateIn"+backadd);
			if(oldslide) oldslide.addClass("animate animateOut"+backadd);
		}

		if (anim){
			this.transition().then(() => {
				//cleanup after transition
				oldslide.hide();
				oldslide.removeClass("animate animateOut"+backadd);
				newslide.removeClass("animate animateIn-prep"+backadd+" animateIn"+backadd);

				this.inTransition=false;

				//trigger after slide change transition complete
				if (this.options.onSlideChanged)
					this.options.onSlideChanged(this,this.slideIndex,oldindex);
					oldslide.removeClass("active");
					newslide.addClass("active");
			});
		} else {
			this.inTransition=false;
			if (this.options.onSlideChanged)
				this.options.onSlideChanged(this,this.slideIndex,oldindex);
		}
	}

	transition() {
		return new Promise((res,rej) => {
			setTimeout(res,this.options.transitionTime);
		});
	}

}
